/**
 * H5 技术性能：当前 app 版本下各 pathname 是否已采样（与 H5_OPEN / is_cold_start 无关）
 */

import { STORAGE_KEY_H5_PERF_ROUTE_VERSION_SEEN } from '@/constants/storage';
import { localStore } from '@/utils/storage';

import packageJson from '../../../../package.json';

interface IRouteVersionPerfSeenStore {
    app_version: string;
    pathnames: string[];
}

function getBundleAppVersion(): string {
    return packageJson.version;
}

/**
 * 性能埋点用 pathname 规范化（末尾 `/` 去掉；根路径保留 `/`）
 */
export function normalizePerfPathname(pathname: string): string {
    const raw = pathname || '/';
    if (raw === '/') {
        return '/';
    }
    return raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

function readStore(): IRouteVersionPerfSeenStore {
    const currentVersion = getBundleAppVersion();
    const raw = localStore.getItem(STORAGE_KEY_H5_PERF_ROUTE_VERSION_SEEN);
    if (!raw) {
        return { app_version: currentVersion, pathnames: [] };
    }
    try {
        const parsed = JSON.parse(raw) as Partial<IRouteVersionPerfSeenStore>;
        if (parsed.app_version !== currentVersion || !Array.isArray(parsed.pathnames)) {
            return { app_version: currentVersion, pathnames: [] };
        }
        return {
            app_version: currentVersion,
            pathnames: parsed.pathnames.filter((p): p is string => typeof p === 'string'),
        };
    } catch {
        return { app_version: currentVersion, pathnames: [] };
    }
}

function writeStore(store: IRouteVersionPerfSeenStore): void {
    localStore.setItem(STORAGE_KEY_H5_PERF_ROUTE_VERSION_SEEN, JSON.stringify(store));
}

/**
 * 当前 bundle 版本下，该 pathname 是否尚未完成过一次 H5 路由性能上报
 */
export function peekIsRouteVersionFirstLoad(pathname: string): boolean {
    const key = normalizePerfPathname(pathname);
    const store = readStore();
    return !store.pathnames.includes(key);
}

/**
 * 性能埋点上报成功后调用，将 pathname 记入本版本已采样集合
 */
export function markRouteVersionPerfReported(pathname: string): void {
    const key = normalizePerfPathname(pathname);
    const store = readStore();
    if (store.pathnames.includes(key)) {
        return;
    }
    writeStore({
        app_version: store.app_version,
        pathnames: [...store.pathnames, key],
    });
}
